import { useSetAtom } from 'jotai';
import { useAtomValue } from 'jotai/utils';
import callApi from 'lib/callApi';
import { showFailureToast, showSuccessToast } from 'lib/ToastHelper';
import { useState } from 'react';
import { companyIdAtom } from 'views/state';

import { forceReloadAccountsAtom, forceRerenderUIAtom } from './state';
import { forceReloadRepoDataAtom } from '../Repositories/state';

const useActivateDeactivateAccount = () => {
  const [loading, setLoading] = useState(false);
  const setForceRerenderUI = useSetAtom(forceRerenderUIAtom);
  const setForceReloadAccountsData = useSetAtom(forceReloadAccountsAtom);
  const setForceReloadRepoData = useSetAtom(forceReloadRepoDataAtom);
  const companyId = useAtomValue(companyIdAtom);

  const handleActivateDeactivateAccount = async (
    accountId: number,
    isActive: boolean,
    accountRowData: any = null,
  ) => {
    const data = {
      company_id: companyId,
      is_active: isActive,
    };

    setLoading(true);
    try {
      const res = await callApi(
        `sast/accounts/activation/${accountId}/`,
        'PATCH',
        {},
        data,
      );
      if (res.status === 200) {
        if (accountRowData) {
          const fields = [
            'is_active',
            'deactivated_at',
            'deactivated_by',
            'reactivated_at',
            'reactivated_by',
            'updated_at',
          ];

          // update the data
          fields.forEach((field) => {
            accountRowData[field] = res.data[field];
          });
        } else {
          setForceReloadAccountsData(Math.random().toString());
        }
        setForceRerenderUI(Math.random().toString());
        setForceReloadRepoData(Math.random().toString());
        const message = `Account is successfully ${
          isActive ? 'activated' : 'deactivated'
        }.`;
        showSuccessToast(message);
        return { success: true, message: message };
      }
    } catch (err) {
      const error = err as any;
      const message = `Failed ${
        isActive ? 'activate' : 'deactivate'
      } account. ${error?.statusText} : ${error?.data?.error}`;
      console.error(message);
      showFailureToast(message);
      return {
        success: false,
        message: message,
      };
    } finally {
      setLoading(false);
    }
  };

  return { loading, handleActivateDeactivateAccount };
};

export default useActivateDeactivateAccount;
